export default "__VITE_ASSET__8da02d37__"